import Vue from 'vue'

/**
 * @autor José Luis R. <jose.ruiz@jbge.com>
 */

const updateSinisterPackage = (id, relatedAffected, deletedAffected, dolar) => {
  const payload = {
    related_affected: relatedAffected.map(a => a.id),
    deleted_affected: deletedAffected.map(a => a.id),
    exchange_price: Number(dolar).toFixed(6),
  }

  return Vue.$http.put(`extranet/package/detail/${id}/`, payload)
    .then(response => response.data)
    .catch((err) => { throw err })
}

export default updateSinisterPackage


// WEBPACK FOOTER //
// ./src/services/extranet/updateSinisterPackage.js